export default {
  data () {
    return {
      results: [],
      loading: false
    }
  },
  methods: {
    async doSearch (filters = {}, successCallback = () => {}, errorCallback = () => {}) {
      filters.value = String(filters.value || '')
      this.loading = true
      const { status, payload } = await this.$post('v1/invoice/search', {
        filter: filters.value,
        partially_paid: filters.partially_paid || false
      })
      this.loading = false
      if (status === 'success') {
        this.results = payload.invoices
        successCallback()
      }
      else {
        errorCallback()
      }
    }
  }
}
